import markdownit from "markdown-it"
import hljs from "highlight.js"

const md = markdownit({
  html: true,
  linkify:true,
  highlight: (str, lang) => {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return hljs.highlight(str, { language: lang }).value
      } catch (__) {
        return ""
      }
    }
    return ""
  }
})

// eslint-disable-next-line @typescript-eslint/unbound-method
const originalValidateLink = md.validateLink

md.validateLink = (url) => {
  const isSvgBase64 = url.startsWith("data:image/svg+xml;base64,")
  if (isSvgBase64) {
    return true
  }
  
  return originalValidateLink(url)
}

export const getHtmlFromMarkdown = (options: {
  markdown: string
}): string => {
  const { markdown } = options

  return md.render(markdown).replace(/\n+$/, "")
}

export default md
